/**
 * This is the i18n configuration file. It is used to load the translations from the server.
 * 
 * SRC: https://dev.to/franklin030601/building-a-multi-language-app-with-react-js-2och
 */
import i18n from "i18next";
import i18nBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: "en",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${import.meta.env.BASE_URL}i18n/{{lng}}.json`,
    },
  });

export default i18n;

